import { render, staticRenderFns } from "./BarEChart.vue?vue&type=template&id=4d23bd8b&scoped=true"
import script from "./BarEChart.vue?vue&type=script&lang=js"
export * from "./BarEChart.vue?vue&type=script&lang=js"
import style0 from "./BarEChart.vue?vue&type=style&index=0&id=4d23bd8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d23bd8b",
  null
  
)

export default component.exports